export default __webpack_public_path__ + "static/media/p_wdt_c_3.978b68f8.mp3";